import tutor from '../../assets/icons/tutor.svg';
import grocery from '../../assets/icons/grocery.svg';

const data_projects = [
  {
    name: 'Tutor-Time',
    image: tutor,
    github_url: 'https://github.com/lorena57/Tutor-Time',
    category: ['Rails', 'SQL'],
  },
  {
    name: 'My Groceries',
    image: grocery,
    github_url: 'https://github.com/lorena57/my_groceries_frontend',
    category: ['JavaScript', 'PostgreSQL', 'Rails'],
  },
  {
    name: 'All In One',
    image: grocery,
    github_url: 'https://github.com/lorena57/all-in-one-again-front-end',
    category: ['PostgreSQL', 'React', 'Rails'],
  },
];

export default data_projects;
